<template>
<router-link
    :to=" { name: 'campaigns-edit', params: { id: params.data.campaignId }, query: { step: 3, adset: params.data.adsetId } }"
>
    <span id="ads-table-edit-button" class="font-medium">
        Edit
    </span>
</router-link>
</template>
<script>
export default {}
</script>
